/**
 * Convert spacing value with unit
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

/**
 * Convert spacing value with unit
 */
export const formatSpacingValue = (
	value: string | undefined,
	unit: string = 'px',
): string => {
	if ( ! value || value === '' ) return '';
	if ( value === 'auto' ) return 'auto';

	// If value already has a unit, return as is
	if ( /[a-zA-Z%]/.test( value ) ) {
		return value;
	}

	// Add unit to numeric values
	return `${ value }${ unit }`;
};
